import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { NoteContent } from '@elsevier-health/osmosis-shared/types/learndb/learnData';
import NotesPageRelatedVideosBlock from './blocks/NotesPageRelatedVideosBlock';

interface NotesPageRightSectionProps {
  contents?: NoteContent[];
  isFullscreen: boolean;
}

/**
 * Left section of the Notes page displaying the contents block,title and HYN info.
 */
const NotesPageRightSection = ({
  contents,
  isFullscreen,
}: NotesPageRightSectionProps) => {
  return (
    <Flex
      className="fixed right-4 top-4 h-screen w-1/4 flex-col overflow-y-scroll pb-4"
      data-testid={'notesPage.rightsection'}
    >
      {!isFullscreen && <NotesPageRelatedVideosBlock contents={contents} />}
    </Flex>
  );
};

export default NotesPageRightSection;
